@use '~/theme/theme' as *;

.dialog {
  gap: spacing(5);
}

.radioGroupContainer {
  border: 1px solid color(grey-300);
  padding: spacing(2);

  @include border-radius(md);
}
